/* ============================================================
   VOLTIST — shared behaviors for custom sections
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 0. Scroll reveal (transform-only, content always visible) ---------- */
  (function initReveal() {
    try {
      var els = document.querySelectorAll('.v-fade');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (e) { e.classList.add('v-in'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('v-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
      var vh = window.innerHeight || 800;
      els.forEach(function (e) {
        if (e.getBoundingClientRect().top < vh * 0.92) { e.classList.add('v-in'); }
        else { io.observe(e); }
      });
      setTimeout(function () {
        document.querySelectorAll('.v-fade:not(.v-in)').forEach(function (e) { e.classList.add('v-in'); });
      }, 2000);
    } catch (err) {
      document.querySelectorAll('.v-fade').forEach(function (e) { e.classList.add('v-in'); });
    }
  })();

  /* ---------- 1. #atcSubmit interceptor ----------
     Any link/button with href="#atcSubmit" triggers the real
     add-to-cart button of the page (Horizon product form),
     which adds the item and auto-opens the cart drawer. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href="#atcSubmit"], [data-atc-submit]');
    if (!link) return;
    e.preventDefault();
    var btn = document.querySelector(
      'product-form-component .add-to-cart-button, form[action*="/cart/add"] .add-to-cart-button, button.add-to-cart-button'
    );
    if (btn) {
      btn.click();
    } else {
      // No product form on this page — go to the product page
      var fallback = link.getAttribute('data-fallback-url') || '/';
      window.location.href = fallback;
    }
  });

  /* ---------- 2. Scroll-snap carousels ---------- */
  function initCarousel(root) {
    var track = root.querySelector('.v-carousel__track');
    if (!track) return;
    var prev = root.querySelector('.v-carousel__arrow--prev');
    var next = root.querySelector('.v-carousel__arrow--next');
    var dotsWrap = root.querySelector('.v-carousel__dots');
    var slides = Array.prototype.slice.call(track.children);
    var rtl = document.documentElement.dir === 'rtl';

    function slideWidth() {
      var s = slides[0];
      if (!s) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || 16);
      return s.getBoundingClientRect().width + gap;
    }
    function currentIndex() {
      var w = slideWidth();
      if (!w) return 0;
      var pos = Math.abs(track.scrollLeft);
      return Math.round(pos / w);
    }
    /* Manual rAF animation: assigning scrollLeft directly works even when
       scroll-snap-type is mandatory, whereas native smooth scrollTo() gets
       yanked back to the origin by the snap engine. Snap is turned off for
       the duration of the animation and restored at the end so touch swipe
       still snaps. */
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var w = slideWidth();
      if (!w) return;
      var max = track.scrollWidth - track.clientWidth;
      var target = Math.min(i * w, max);
      if (rtl) target = -target;
      var start = track.scrollLeft;
      var change = target - start;
      if (Math.abs(change) < 1) return;
      var t0 = null, dur = 340;
      track.style.scrollSnapType = 'none';
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        track.scrollLeft = start + change * e;
        if (p < 1) { requestAnimationFrame(step); }
        else { track.style.scrollSnapType = ''; }
      }
      requestAnimationFrame(step);
    }
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.className = 'v-carousel__dot';
        d.type = 'button';
        d.setAttribute('aria-label', 'שקופית ' + (i + 1));
        d.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(d);
      });
    }
    // thumbnail strip (PDP + homepage galleries): sibling of the carousel, each thumb drives goTo
    var thumbsWrap = root.parentElement && root.parentElement.querySelector('.vx-pdp__thumbs, .vx-fp__thumbs');
    var thumbBtns = thumbsWrap ? Array.prototype.slice.call(thumbsWrap.children) : [];
    thumbBtns.forEach(function (btn, ti) { btn.addEventListener('click', function () { goTo(ti); }); });
    function refresh() {
      var i = currentIndex();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, di) {
          d.setAttribute('aria-current', di === i ? 'true' : 'false');
        });
      }
      if (thumbBtns.length) {
        thumbBtns.forEach(function (b, bi) { b.setAttribute('aria-current', bi === i ? 'true' : 'false'); });
      }
      // pause videos on non-active slides, play on active (opt-in via data-active-play)
      slides.forEach(function (s, si) {
        var v = s.querySelector('video[data-active-play]');
        if (!v) return;
        v.muted = true;
        if (si === i) { v.play().catch(function () {}); } else { v.pause(); }
      });
    }
    // Arrows: in RTL "next" moves to the following slide (visually left)
    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(refresh, 80); }, { passive: true });
    refresh();

    // autoplay
    var auto = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    if (auto > 0) {
      setInterval(function () {
        var i = currentIndex();
        goTo(i >= slides.length - 1 ? 0 : i + 1);
      }, auto * 1000);
    }
  }
  document.querySelectorAll('.v-carousel').forEach(initCarousel);

  /* ---------- 1b. Buy CTAs on the product page scroll to the buybox ----------
     Buttons across the PDP sections link to the product URL (or have an empty
     href). When we're ALREADY on that page, a click would just reload it —
     instead, smooth-scroll up to the buybox. On other pages (e.g. homepage)
     the links keep navigating normally. Real hash links (#...) are untouched. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.v-btn, a.vx-hero__badge');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('#') > -1 && href.split('#')[1]) return; // real anchors keep working
    var path = href.split('#')[0].split('?')[0];
    if (path !== '' && path !== location.pathname) return;    // different page -> navigate
    var target = document.querySelector('.vx-pdp');
    if (!target) return;                                      // not on the product page
    e.preventDefault();
    var top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - 70);
    window.scrollTo({ top: top, behavior: 'smooth' });
  });

  /* ---------- 2b. UGC videos: click to play/pause (YouTube-style) ----------
     Nothing autoplays. Tap starts the video WITH sound (user gesture allows
     it); tapping again pauses. Starting one pauses all the others. */
  document.addEventListener('click', function (e) {
    var slide = e.target.closest('.vx-ugc__slide');
    if (!slide) return;
    var v = slide.querySelector('video');
    if (!v) return;
    if (v.paused) {
      document.querySelectorAll('.vx-ugc__slide video').forEach(function (o) {
        if (o !== v) { o.pause(); var s2 = o.closest('.vx-ugc__slide'); if (s2) s2.classList.remove('vx-playing'); }
      });
      v.muted = false;
      v.play().catch(function () { v.muted = true; v.play().catch(function () {}); });
      slide.classList.add('vx-playing');
    } else {
      v.pause();
      slide.classList.remove('vx-playing');
    }
  });

  /* ---------- 3. Modals ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      e.preventDefault();
      var m = document.querySelector(opener.getAttribute('data-modal-open'));
      if (m) { m.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; }
      return;
    }
    var closer = e.target.closest('[data-modal-close]');
    var backdrop = e.target.classList && e.target.classList.contains('v-modal');
    if (closer || backdrop) {
      var open = e.target.closest('.v-modal') || e.target;
      if (open) { open.removeAttribute('data-open'); document.body.style.overflow = ''; }
    }
  });

  /* ---------- 4. Deferred videos (click poster -> play) ---------- */
  document.addEventListener('click', function (e) {
    var d = e.target.closest('.v-video-defer[data-video-src]');
    if (!d) return;
    var v = document.createElement('video');
    v.src = d.getAttribute('data-video-src');
    v.autoplay = true;
    v.loop = true;
    v.muted = d.getAttribute('data-controls') !== 'true';
    v.playsInline = true;
    if (d.getAttribute('data-controls') === 'true') v.controls = true;
    v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
    d.innerHTML = '';
    d.appendChild(v);
    d.classList.add('v-video-loaded');
  });

  /* ---------- 5. Progress circles (animate on view) ---------- */
  var circles = document.querySelectorAll('.v-circle[data-pct]');
  if (circles.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var target = parseInt(el.getAttribute('data-pct'), 10) || 0;
        var cur = 0;
        var step = function () {
          cur += Math.max(1, Math.round(target / 40));
          if (cur >= target) cur = target;
          el.style.setProperty('--pct', cur);
          el.setAttribute('data-label', cur + '%');
          if (cur < target) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    circles.forEach(function (c) { io.observe(c); });
  }

  /* ---------- 6. Timeline scroll progress ---------- */
  var timeline = document.querySelector('.v-timeline');
  if (timeline) {
    var steps = timeline.querySelectorAll('.v-timeline__step');
    function onScroll() {
      var rect = timeline.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = rect.height;
      var passed = Math.min(Math.max(vh * 0.5 - rect.top, 0), total);
      timeline.style.setProperty('--timeline-progress', (passed / total * 100) + '%');
      steps.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top < vh * 0.72) s.classList.add('active');
        else s.classList.remove('active');
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 7. (fade handled at top, section 0) ---------- */

  /* ---------- 8. Custom buy form (homepage featured product) ---------- */
  document.querySelectorAll('.v-buy-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var oldText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'מוסיף...'; }
      // gather what to add: chosen glasses variant + optional deal gift + always-on freebie (the book)
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var mainId = idInput ? idInput.value : null;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var dealsWidget = form.querySelector('.v-deals');
      var selDeal = dealsWidget ? dealsWidget.querySelector('.v-deal[data-selected]') : null;
      var giftId = selDeal ? (selDeal.getAttribute('data-gift-id') || '') : '';
      var freebieId = form.getAttribute('data-always-gift') || '';
      // the subscription plan the shopper ticked in the buy box. this handler builds
      // its own items[] payload, so a plan that is not copied in here is dropped in
      // silence and the order is billed as a one time purchase. the input stays
      // disabled while no plan is chosen, because /cart/add rejects an empty
      // selling_plan instead of ignoring it.
      var planInput = form.querySelector('input[name="selling_plan"]');
      var sellingPlan = planInput && !planInput.disabled && planInput.value ? planInput.value : '';
      // read the cart first so free gifts are never added twice
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var inCart = {};
          (cart.items || []).forEach(function (it) { inCart[String(it.variant_id)] = true; });
          var mainItem = { id: mainId, quantity: qty };
          // only the product itself carries the plan: a free gift has no allocation
          // on that plan and the whole request would come back as an error
          if (sellingPlan) { mainItem.selling_plan = sellingPlan; }
          var items = [mainItem];
          if (giftId && !inCart[String(giftId)]) { items.push({ id: giftId, quantity: 1, properties: { 'מתנה': '🎁 כלול חינם בהזמנה' } }); }
          if (freebieId && !inCart[String(freebieId)]) { items.push({ id: freebieId, quantity: 1, properties: { 'מתנה': '📘 ספר 33 טיפים ליופי במתנה' } }); }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: form.id || 'voltist-buy-form',
                data: { source: 'product-form', itemCount: cart.item_count, variantId: String(mainId) }
              }
            }));
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              window.location.href = '/cart';
            }
            if (btn) { btn.textContent = '✓ נוסף לעגלה'; setTimeout(function () { btn.disabled = false; btn.textContent = oldText; }, 2500); }
          });
        })
        .catch(function () {
          // graceful fallback: native POST (redirects to /cart)
          form.removeAttribute('data-js');
          if (btn) { btn.disabled = false; btn.textContent = oldText; }
          form.submit();
        });
    });
  });

  /* variant swatches inside custom buy form (homepage): pick the variant + show its name */
  document.querySelectorAll('.v-buy-form .v-variant-pill input, .v-buy-form .vx-fp-swatch input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('.v-buy-form');
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = input.value;
      var wrap = input.closest('.vx-fp__color');
      var valEl = wrap && wrap.querySelector('.vx-fp__color-value');
      var title = input.getAttribute('data-title');
      if (valEl && title) { valEl.textContent = title; }
    });
  });

  /* color swatches (outside the form, linked via form attr): pick the variant + show its name */
  document.querySelectorAll('input[name="vx-variant-src"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var formId = input.getAttribute('form');
      var form = formId ? document.getElementById(formId) : document.querySelector('.v-buy-form');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = input.value;
      var wrap = input.closest('.vx-pdp__color');
      var valEl = wrap && wrap.querySelector('.vx-pdp__color-value');
      var title = input.getAttribute('data-title');
      if (valEl && title) { valEl.textContent = title; }
    });
  });

  /* ---------- 8b. Deal-bars widget (scoped to nearest form) ---------- */
  document.querySelectorAll('.v-deals').forEach(function (widget) {
    var bars = widget.querySelectorAll('.v-deal');
    var form = widget.closest('form') || document.querySelector('form[action*="/cart/add"]');
    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        bars.forEach(function (b) { b.removeAttribute('data-selected'); });
        bar.setAttribute('data-selected', '');
        var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
        var qty = bar.getAttribute('data-qty') || '1';
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  /* ---------- 9. Comparison table dots (mobile swipe) ---------- */
  document.querySelectorAll('.vx-cmp').forEach(function (cmp) {
    var scroll = cmp.querySelector('.vx-cmp__scroll');
    var dotsWrap = cmp.querySelector('.vx-cmp__dots');
    if (!scroll || !dotsWrap) return;
    var dots = Array.prototype.slice.call(dotsWrap.children);
    var cols = scroll.querySelectorAll('.vx-cmp__col');
    var rtl = document.documentElement.dir === 'rtl';
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var colW = cols[0] ? cols[0].offsetWidth : 1;
        scroll.scrollTo({ left: (rtl ? -1 : 1) * i * colW, behavior: 'smooth' });
      });
    });
    function refreshDots() {
      var w = cols[0] ? cols[0].offsetWidth : 1;
      var idx = Math.round(Math.abs(scroll.scrollLeft) / w);
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === Math.min(idx, dots.length - 1) ? 'true' : 'false'); });
    }
    scroll.addEventListener('scroll', refreshDots, { passive: true });
    if (dots[0]) dots[0].setAttribute('aria-current', 'true');
  });

  /* ---------- 10. Cart-drawer upsell (pink, injected into the Horizon drawer) ---------- */
  (function () {
    var src = document.getElementById('vx-upsell-src');
    if (!src) return;
    var UP = Array.prototype.map.call(src.querySelectorAll('.vx-upsell-data'), function (d) {
      return {
        pid: d.getAttribute('data-pid'),
        vid: d.getAttribute('data-vid'),
        title: d.getAttribute('data-title'),
        url: d.getAttribute('data-url'),
        img: d.getAttribute('data-img'),
        price: d.getAttribute('data-price'),
        compare: d.getAttribute('data-compare')
      };
    });
    if (!UP.length) return;
    var UP_TITLE = src.getAttribute('data-title') || 'מומלצים בשבילך';
    var cartPids = {};

    function setPidsFromCart(cart) {
      cartPids = {};
      (cart.items || []).forEach(function (it) { cartPids[String(it.product_id)] = true; });
    }
    function refreshCart(cb) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { setPidsFromCart(cart); if (cb) cb(); })
        .catch(function () { if (cb) cb(); });
    }
    function build() {
      var show = UP.filter(function (i) { return !cartPids[String(i.pid)]; });
      if (!show.length) return null;
      var wrap = document.createElement('div');
      wrap.className = 'vx-upsell';
      wrap.setAttribute('data-vx-upsell', '');
      var h = '<div class="vx-upsell__title">' + UP_TITLE + '</div><div class="vx-upsell__list">';
      show.slice(0, 4).forEach(function (i) {
        h += '<div class="vx-upsell__item">'
          + '<a class="vx-upsell__thumb" href="' + i.url + '"><img src="' + i.img + '" alt="" loading="lazy"></a>'
          + '<div class="vx-upsell__info"><a class="vx-upsell__name" href="' + i.url + '">' + i.title + '</a>'
          + '<div class="vx-upsell__price">' + (i.compare ? '<s>' + i.compare + '</s>' : '') + '<b>' + i.price + '</b></div></div>'
          + '<button type="button" class="vx-upsell__add" data-vid="' + i.vid + '" aria-label="הוסף לעגלה">+</button>'
          + '</div>';
      });
      h += '</div>';
      wrap.innerHTML = h;
      return wrap;
    }
    function inject() {
      var content = document.querySelector('cart-drawer-component .cart-drawer__content');
      if (!content) return;
      var old = content.querySelector('[data-vx-upsell]');
      if (old) old.remove();
      var el = build();
      if (!el) return;
      // pin the upsell at the TOP of the cart (sticky via CSS) so it's always seen, never scrolled past
      content.insertBefore(el, content.firstChild);
    }
    function isDrawerOpen() {
      var dlg = document.querySelector('cart-drawer-component dialog.cart-drawer__dialog');
      return !!(dlg && (dlg.open || dlg.hasAttribute('open')));
    }
    // add button (delegated)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.vx-upsell__add');
      if (!btn) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-vid');
      if (!vid) return;
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          setPidsFromCart(cart);
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'vx-upsell', data: { source: 'vx-upsell', itemCount: cart.item_count } } }));
          setTimeout(inject, 450);
        })
        .catch(function () { btn.disabled = false; });
    });
    // refresh filtering whenever the cart changes
    document.addEventListener('cart:update', function () { refreshCart(function () { setTimeout(inject, 300); }); });
    // re-inject when the drawer opens or Horizon re-renders its content (guarded to avoid loops)
    var comp = document.querySelector('cart-drawer-component');
    if (comp) {
      var mo = new MutationObserver(function () {
        if (!isDrawerOpen()) return;
        var content = document.querySelector('cart-drawer-component .cart-drawer__content');
        if (content && !content.querySelector('[data-vx-upsell]')) inject();
      });
      mo.observe(comp, { attributes: true, childList: true, subtree: true });
    }
    refreshCart(function () { if (isDrawerOpen()) inject(); });
  })();

  /* ---------- 11. WhatsApp floating button repair ----------
     The Sense-WA app embed renders wa.me/9720XXXXXXXXX (extra leading 0 after 972 —
     a dead link) and an icon hotlinked from Wikipedia that fails to load. We can't
     edit the app's config from the theme, so patch the rendered link + swap the
     broken img for an inline WhatsApp glyph. Timed retries only — no observers. */
  (function () {
    var WA_SVG = 'data:image/svg+xml;utf8,' + encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#ffffff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>'
    );
    function fixWa() {
      document.querySelectorAll('a[href*="wa.me/9720"]').forEach(function (a) {
        a.href = a.href.replace('wa.me/9720', 'wa.me/972');
      });
      document.querySelectorAll('a[href*="wa.me"] img').forEach(function (img) {
        if (img.complete && img.naturalWidth === 0) { img.src = WA_SVG; }
      });
    }
    [900, 2200, 4500].forEach(function (t) { setTimeout(fixWa, t); });
  })();
})();
